import type { LocalOrSavedFile } from '@frontend/api-types';
import { getNameFromFile, getTypeFromFile } from '@frontend/forms';
import { Icon, Text, XStack, YStack } from '@frontend/web-react';
import { mergeAndConcatClasses } from '@frontend/web-utils';

export const FilePreview = ({
  className,
  file,
  onClick,
  onRemove,
}: {
  className?: string;
  file: LocalOrSavedFile;
  onClick?: () => void;
  onRemove?: () => void;
}) => (
  // eslint-disable-next-line tailwindcss/no-arbitrary-value
  <XStack className={mergeAndConcatClasses('w-[150px] rounded-lg', className)} key={file.url}>
    <XStack
      className="relative items-center border-borderPrimary rounded-lg border-1 gap-sm p-sm flex-1"
      enableHoverEffect
      key={file.url}
      onClick={onClick}
    >
      {onRemove ? (
        <YStack
          // eslint-disable-next-line tailwindcss/no-arbitrary-value,tailwindcss/no-custom-classname
          className="bg-trueWhite p-px absolute right-[-6px] top-[-6px] cursor-pointer rounded-full"
          onClick={(e) => {
            e.stopPropagation();
            onRemove();
          }}
        >
          <YStack className="bg-neutral-950 rounded-xl p-xs">
            <Icon className="text-trueWhite" color="white" name="IconX" size={10} />
          </YStack>
        </YStack>
      ) : null}
      <Icon name="IconFile" size={20} />
      <YStack className="min-w-0">
        <Text className="line-clamp-3 break-all" type="h6">
          {getNameFromFile(file)}
        </Text>
        <Text color="secondary" type="caption">
          {getTypeFromFile(file)}
        </Text>
      </YStack>
    </XStack>
  </XStack>
);
